import { render, staticRenderFns } from "./genelamaclicari.vue?vue&type=template&id=5ebb2514"
import script from "./genelamaclicari.vue?vue&type=script&lang=js"
export * from "./genelamaclicari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports